import { useState } from "react";
import { useDispatch } from "react-redux";
import _ from 'lodash';

import { handleOpenDestinationEditDialog, showAlertSnackbar } from "../../../reducers/uiSlice";
import UniDialog from "../../Common/UniDialog";
import DestinationEditForm from "../../EditOrderModal/DestinationEditForm";
import { editOrderAddress, updateOrderInfo } from "../../../actions/editOrderActions";
import { getDriverOrders } from "../../../actions/mmActions";
import { getUserPreference } from "../../../utilities/common";


function DestinationEditModal(props){
    const {open, order, selectBatchIds} = props

    const userPref = getUserPreference();
    const dispatch = useDispatch();

    const [editObj, setEditObj] = useState({})

    return (
        <UniDialog
            title="Destination Edit"
            open={open}
            onClose={()=>{
                dispatch(handleOpenDestinationEditDialog(false));
                setEditObj({})
            }}
            onFinish={()=>{
                handleDestinationEditSubmit()
            }}
        >
            <DestinationEditForm 
                order={order}
                onInputChange={(obj)=>setEditObj(obj)}
                simplified
            />
        </UniDialog>
    )

    async function handleDestinationEditSubmit(){
        console.log(editObj)
        const autoLatLng = userPref.autoLatLng

        try {
            await dispatch(updateOrderInfo(order.orderId, editObj))
            if(autoLatLng && _.has(editObj, 'address')){
                await dispatch(editOrderAddress(order.orderId, editObj.address, 1))
                await dispatch(getDriverOrders(order.shipping_staff_id, selectBatchIds, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity))
            }
            setEditObj({})
            dispatch(handleOpenDestinationEditDialog(false))
        } catch(error){
            dispatch(showAlertSnackbar({title: "Edit Address", message: error.message || "An error has occurred, Please try again!"}))
        }
    }
}

DestinationEditModal.defaultProps = {
    order:{},
    open: false,
    selectBatchIds: []
}

export default DestinationEditModal